import { useSelector } from 'react-redux';

import { type ExchangeModule } from '../types/exchanges';

type RootState = { login: { disabledModules?: ExchangeModule[] } };

const NONE: ExchangeModule[] = [];

/** The modules the user's own exchange has not bought, as /user/me describes them. */
export function useDisabledModules(): ExchangeModule[] {
  return useSelector((state: RootState) => state.login.disabledModules) ?? NONE;
}
